<template>
  <slot
    v-if="url && videoId && embedUrl"
    :video-id="videoId"
    :embed-url="embedUrl"
    :thumbnail-url="thumbnailUrl"
  />
</template>

<script setup>
import { computed } from "#imports";
import {
  buildYouTubeThumbnailUrl,
  extractVimeoId,
  extractYouTubeId
} from "../../helpers/video";
const props = defineProps({
  url: { type: String, required: false, default: "" }
});
defineSlots();
var VideoSourcePlatform = /* @__PURE__ */ ((VideoSourcePlatform2) => {
  VideoSourcePlatform2["YOUTUBE"] = "youtube";
  VideoSourcePlatform2["VIMEO"] = "vimeo";
  return VideoSourcePlatform2;
})(VideoSourcePlatform || {});
const kind = computed(() => {
  if (props.url.toLowerCase().includes("youtu")) {
    return "youtube" /* YOUTUBE */;
  }
  if (props.url.toLowerCase().includes("vimeo")) {
    return "vimeo" /* VIMEO */;
  }
  return void 0;
});
const videoId = computed(() => {
  if (kind.value === "youtube" /* YOUTUBE */) {
    return extractYouTubeId(props.url);
  } else if (kind.value === "vimeo" /* VIMEO */) {
    return extractVimeoId(props.url);
  }
  return "";
});
const embedUrl = computed(() => {
  if (kind.value === "youtube" /* YOUTUBE */) {
    return `https://www.youtube.com/embed/${videoId.value}?modestbranding=1&rel=0&autoplay=1`;
  } else if (kind.value === "vimeo" /* VIMEO */) {
    return `https://player.vimeo.com/video/${videoId.value}?autoplay=1`;
  }
  return "";
});
const thumbnailUrl = computed(() => {
  if (kind.value === "youtube" /* YOUTUBE */ && videoId.value) {
    return buildYouTubeThumbnailUrl(videoId.value);
  }
  return "";
});
</script>
